import { IStore } from '../../../common/store';

const getCurrentDealReducer = (state: IStore) => {
  return state.customiseCombinedReducer.currentDealReducer;
};

const currentDealSelectors = {
  getCurrentDeal: (state: IStore) => getCurrentDealReducer(state).currentDeal,
  getPartExchangeId: (state: IStore) => getCurrentDealReducer(state).currentDeal?.partExchangeId,
  getLoadingStatus: (state: IStore) => getCurrentDealReducer(state).loading,
  getErrorStatus: (state: IStore) => getCurrentDealReducer(state).error,
  getIsMultiCurrency: (state: IStore) => getCurrentDealReducer(state).prices.isMultiCurrency,
  getIsCash: (state: IStore) => getCurrentDealReducer(state).financeQuote?.isCashProduct,
  getCarPrices: (state: IStore) => getCurrentDealReducer(state).prices.carPrices,
  getTotalAmountPayable: (state: IStore) => getCurrentDealReducer(state).prices.totalAmountPayable,
  getPrimaryPrice: (state: IStore) => getCurrentDealReducer(state).prices.primaryPrice,
  getPrimaryPriceTotal: (state: IStore) => getCurrentDealReducer(state).prices.primaryTotalPrice,
  getSecondaryPriceTotal: (state: IStore) => getCurrentDealReducer(state).prices.secondaryTotalPrice,
  getSecondaryPrice: (state: IStore) => getCurrentDealReducer(state).prices.secondaryPrice,
  getServicePlan: (state: IStore) => getCurrentDealReducer(state).servicePlan,
  getServicePlanPrice: (state: IStore) => getCurrentDealReducer(state).prices.servicePlanPrice,
  getAccessories: (state: IStore) => getCurrentDealReducer(state).accessories,
  getAccessoryPacks: (state: IStore) => getCurrentDealReducer(state).accessoryPacks,

  // Finance quote data
  getFinanceQuoteDuration: (state: IStore) => getCurrentDealReducer(state).financeQuote?.duration,
  getFinanceQuoteInterestRate: (state: IStore) => getCurrentDealReducer(state).financeQuote?.interestRate,
  getFinanceQuoteComparisonRate: (state: IStore) => getCurrentDealReducer(state).financeQuote?.comparisonRate,
  getFinanceQuote: (state: IStore) => getCurrentDealReducer(state).financeQuote,
  getFinanceDisclaimers: (state: IStore) => getCurrentDealReducer(state).financeQuote?.disclaimers,
  getFinanceDeposit: (state: IStore) => getCurrentDealReducer(state).financeQuote?.deposit,
  getSecondaryCurrencyQuote: (state: IStore) => getCurrentDealReducer(state).financeQuote?.secondaryCurrencyQuote,
};

export default currentDealSelectors;
